import * as React from 'react';
import { List, StyledComponentProps } from '@material-ui/core';
import { contactInsurance, contactMedicalExamination, contactSubscription } from '../../../../model/contactsubscription';
import { SubscriptionItem } from './SubscriptionItem';
import { InsuranceItem } from './InsuranceItem';
import { MedicalItem } from './MedicalItem';

interface IProps extends StyledComponentProps {
    contactSubscriptions: Array<contactSubscription>;
    contactMedicalExaminations: Array<contactMedicalExamination>;
    contactInsurances: Array<contactInsurance>;
    onSelectItem: (item: contactSubscription | contactMedicalExamination | contactInsurance) => void;
}

export const ContactPurchasedList = (props: IProps) => {
    const classes = props.classes;
    return (
        <List className={classes?.rootPurchased}>
            {props.contactSubscriptions && props.contactSubscriptions.length > 0 && props.contactSubscriptions.map(s =>
                <SubscriptionItem
                    onSelectItem={() => props.onSelectItem(s as contactSubscription)}
                    key={s._id}
                    classes={classes}
                    subscription={s}
                />
            )}
            {props.contactInsurances && props.contactInsurances.length > 0 && props.contactInsurances.map(i =>
                <InsuranceItem
                    onSelectItem={() => props.onSelectItem(i as contactInsurance)}
                    key={i._id}
                    classes={classes}
                    insurance={i}
                />
            )}
            {props.contactMedicalExaminations && props.contactMedicalExaminations.length > 0 && props.contactMedicalExaminations.map(m =>
                <MedicalItem
                    onSelectItem={() => props.onSelectItem(m as contactMedicalExamination)}
                    key={m._id}
                    classes={classes}
                    medicalExamination={m}
                />
            )}
        </List>)
};